import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center text-center">
      <div>
        <h1 className="fw-bold text-danger" style={{ fontSize: '64px' }}>403</h1>
        <h2 className="fs-4 mb-2">Unauthorized Access</h2>
        <p className="text-muted">You don't have permission to access this resource.</p>
        <Link to="/" className="btn btn-primary mt-2">
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
